<script>
import options from './StafetOpretHoldStepOne.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-opret-hold-step-one kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.aboutYourHoldTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <FormInputTextField
        fieldName="teamName"
        :modelValue="teamName.toString()"
        v-model="teamName"
        :label="labels.aboutYourHoldHoldnavnLabel"
        :isRequired="true"
        :isValidationError="showTeamNameErrorMessage"
        :errorMessageLabel="labels.aboutYourHoldHoldnavnErrorMessage"
        :onChangeCallback="(e) => validateField('teamName', e.target.value)"
      />

      <FormInputTextField
        fieldName="donationGoal"
        :modelValue="donationGoal.toString()"
        v-model="donationGoal"
        type="number"
        :label="labels.aboutYourHoldDonationGoalLabel"
        :isRequired="true"
        :isValidationError="showDonationGoalErrorMessage"
        :errorMessageLabel="labels.aboutYourHoldDonationGoalErrorMessage"
        :onChangeCallback="(e) => validateField('donationGoal', e.target.value)"
        :helpMessageLabel="labels.aboutYourHoldDonationGoalSubtext"
      />
    </div>

    <hr class="kb-stafet-step__breaker-line" />

    <div>
      <h2 class="kb-stafet-step__title">
        {{ labels.personalizeYourHoldTitle }}
      </h2>

      <div v-html="labels.personalizeYourHoldDescription" class="kb-stafet-step__description kb-sfl-richtext"></div>

    </div>

    <label class="kb-form__file-upload FormFileUpload" for="uploadLogo">
      <input
        class="kb-form__file-upload-input FormFileUpload__Input"
        id="uploadLogo"
        type="file"
        accept="image/png, image/jpg, image/jpeg, .svg"
        v-on:change="onFileChange"
      />
      <div class="kb-form__file-upload-svg">
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity=".4" fill="#3C3C3C">
            <path
              d="m20.024 13.05.967-.405-.206-.481c-.84-2.002-.617-4.14.596-5.683 1.214-1.542 3.095-2.264 5.32-2.093l-1.49 1.438.73.75 2.016-1.961a1.008 1.008 0 0 0 0-1.44l-2.016-1.961-.73.75 1.396 1.357c-2.505-.133-4.674.757-6.049 2.518-1.451 1.856-1.72 4.375-.736 6.72l.203.49ZM18.141 24.419v1.046h-5.93v-1.046H.699v2.965a1.214 1.214 0 0 0 1.221 1.22h26.163a1.22 1.22 0 0 0 1.22-1.22v-2.965H18.142Zm10.116 2.965a.174.174 0 0 1-.174.174H1.92a.178.178 0 0 1-.125-.052.175.175 0 0 1-.05-.122v-1.919h9.42v1.047h8.023v-1.047h9.07v1.919ZM4.886 21.977H2.793V9.593a.174.174 0 0 1 .174-.174h14.128V8.372H2.967a1.22 1.22 0 0 0-1.22 1.221v13.43h3.139v-1.046Z"
            />
            <path
              d="M28.256 23.023V9.593a1.22 1.22 0 0 0-1.22-1.22h-4.013v1.046h4.012a.174.174 0 0 1 .174.174v13.43h1.047Z"
            />
          </g>
        </svg>
      </div>
      <div class="kb-form__file-upload-text-wrapper">
        <p class="kb-form__file-upload-text">
          {{ labels.personalizeYourHoldLogoLabel }}
        </p>
        <template v-if="logo && logo[0]">
          <p class="kb-form__file-upload-text-file">
            {{ logo[0] ? logo[0].name : '' }}
          </p>
        </template>
        <small class="kb-form__file-upload-format-types">{{
          labels.personalizeYourHoldLogoFileFormats
        }}</small>
      </div>
    </label>

    <div class="kb-stafet-step__input-wrapper">
      <FormInputTextarea
        fieldName="description"
        :modelValue="description"
        v-model="description"
        :label="labels.personalizeYourHoldReasonLabel"
        :maxlength="250"
        :isValidationError="showDescriptionErrorMessage"
        :errorMessageLabel="labels.personalizeYourHoldReasonErrorMessage"
        :onChangeCallback="(e) => validateField('description', e.target.value)"
      />

      <FormInputTextField
        fieldName="slogan"
        :modelValue="slogan"
        v-model="slogan"
        :label="labels.personalizeYourHoldSloganLabel"
        :maxlength="100"
        :isValidationError="showSloganErrorMessage"
        :errorMessageLabel="labels.personalizeYourHoldSloganErrorMessage"
        :onChangeCallback="(e) => validateField('slogan', e.target.value)"
      />
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep1"
    />
  </article>
</template>
